import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

import Home from "../views/Home.vue";
import Hire from "../views/Hire.vue";
import Register from "../views/Register.vue";
import Login from "../views/Login.vue";
import DevSignup from "../views/DevSignup.vue";
import DevService from "../views/DevService.vue";
import DevProfile from "../views/DevProfile.vue";
import FindJobs from "../views/FindJobs.vue";
import JobDescription from "../views/JobDescription.vue";
import Blog from "../views/Blog.vue";
import Blogpage from "../views/Blogpage.vue";
// import VettingProcess from "../views/VettingProcess.vue";
import VettingProcess from "../views/NewVettingProcess.vue";
// import ItWorks from "../views/HowItWorks.vue";
import ItWorks from "../views/NewHowItWorks.vue";
import DevItWorks from "../views/DevsHowItWorks.vue";
import OnboardingReview from "../views/OnboardingReview.vue";
import RequestToken from "../views/RequestToken.vue";
import VerifyToken from "../views/VerifyToken.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import ResetPassword from "../views/ResetPassword.vue";
import Landing from "../views/Landing.vue";
import FindTalent from "../views/FindTalent.vue";
import HireTalent from "../views/HireTalent.vue";

import DevNo from "../components/Hire/DevNo.vue";
import Stack from "../components/Hire/Stack.vue";
import Stage from "../components/Hire/Stage.vue";
import Specifications from "../components/Hire/Specifications.vue";
import JobPost from "../components/Hire/JobPost.vue";
import JobType from "../components/Hire/JobType.vue";
import Duration from "../components/Hire/Duration.vue";
import Location from "../components/Hire/Location.vue";
import PaymentPerHour from "../components/Hire/PaymentPerHour.vue";
import WorkHours from "../components/Hire/WorkHours.vue";
import Description from "../components/Hire/Description.vue";
// import Business from '../components/Business.vue';
// import Freelancer from '../components/Freelancer.vue';
import Fullname from "../components/DevSignUp/Fullname.vue";
import Speciality from "../components/DevSignUp/Speciality.vue";
import FullstackDev from "../components/DevSignUp/FullstackDev.vue";
import OtherDevs from "../components/DevSignUp/OtherDevs.vue";
import Experience from "../components/DevSignUp/Experience.vue";
import HourlyRates from "../components/DevSignUp/HourlyRates.vue";

import MobileApp from "../components/Services/MobileApp.vue";
import UiUx from "../components/Services/UiUx.vue";
import DataEngr from "../components/Services/DataEngr.vue";
import WebApp from "../components/Services/WebApp.vue";
import Blockchain from "../components/Services/Blockchain.vue";
import Ai from "../components/Services/Ai.vue";
import DevOps from "../components/Services/DevOps.vue";
import CyberSecurity from "../components/Services/CyberSecurity.vue";

import JobRole from "../components/HireTalent/JobRole.vue";
import TechStack from "../components/HireTalent/TechStack.vue";
import TalentExperience from "../components/HireTalent/Experience.vue";
import SignUp from "../components/HireTalent/SignUp.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/home",
    name: "home",
    component: Home,
  },
  {
    path: "/",
    name: "landing",
    component: Landing,
  },
  {
    path: "/hire",
    name: "hire",
    component: Hire,
    children: [
      { path: "", component: Stage },
      { path: "stack", component: Stack },
      { path: "description", component: Description },
      { path: "specifications", component: Specifications },
      { path: "work-hours", component: WorkHours },
      { path: "job-type", component: JobType },
      { path: "location", component: Location },
      { path: "duration", component: Duration },
      { path: "dev-no", component: DevNo },
      { path: "payment", component: PaymentPerHour },
      { path: "make-job-post", component: JobPost },
    ],
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    // children: [
    //   {path:'', component: Business},
    //   {path:'business', component: Business},
    //   {path:'freelancer', component: Freelancer}

    // ]
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/find-talent",
    name: "findtalent",
    component: FindTalent,
  },
  {
    path: "/hire-talent",
    name: "hiretalent",
    component: HireTalent,
    children: [
      { path: "", component: JobRole },
      { path: "tech-stack", component: TechStack },
      { path: "experience", component: TalentExperience },
      { path: "signup", component: SignUp },
    ],
  },
  {
    path: "/devsignup",
    name: "devsignup",
    component: DevSignup,
    children: [
      { path: "", component: Fullname },
      { path: "speciality", component: Speciality },
      { path: "fullstack", component: FullstackDev },
      { path: "devs", component: OtherDevs },
      { path: "experience", component: Experience },
      { path: "complete", component: HourlyRates },
    ],
  },
  {
    path: "/dev-services",
    name: "DevService",
    component: DevService,
    children: [
      { path: "", component: WebApp },
      { path: "mobile-app", component: MobileApp },
      { path: "web-app", component: WebApp },
      { path: "ui-ux", component: UiUx },
      { path: "devops", component: DevOps },
      { path: "cyber-security", component: CyberSecurity },
      { path: "data-engineering", component: DataEngr },
      { path: "blockchain", component: Blockchain },
      { path: "artificial-intelligence", component: Ai },
    ],
  },
  {
    path: "/profile",
    name: "profile",
    component: DevProfile,
  },
  {
    path: "/find-jobs",
    name: "findjobs",
    component: FindJobs,
  },
  {
    path: "/job-description",
    name: "job-description",
    component: JobDescription,
  },
  {
    path: "/blog",
    name: "blog",
    component: Blog,
  },
  {
    path: "/blog/:id",
    name: "blog",
    component: Blogpage,
  },
  {
    path: "/vetting-process",
    name: "vetting-process",
    component: VettingProcess,
  },
  {
    path: "/dev-how-it-works",
    name: "dev-how-it-works",
    component: DevItWorks,
  },
  {
    path: "/how-it-works",
    name: "how-it-works",
    component: ItWorks,
  },
  {
    path: "/onboarding-review",
    name: "onboarding-review",
    component: OnboardingReview,
  },
  {
    path: "/request_token",
    name: "request_token",
    component: RequestToken,
  },
  {
    path: "/verify",
    name: "verify",
    component: VerifyToken,
  },
  {
    path: "/forgot_password",
    name: "forgot_password",
    component: ForgotPassword,
  },
  {
    path: "/reset_password",
    name: "reset_password",
    component: ResetPassword,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    window.scrollTo(0, 0);
    // document.getElementById('app').scrollIntoView();
  },
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next("/login");
  }
  // if(to.fullPath === '/login'){
  //   if(store.getters.isLoggedIn){
  //     next('/home');
  //     return
  //   }
  // }
  else {
    next();
  }
});

export default router;
